function ProtectedRoute({ children }) {
	// if (
	// 	pathname !== "/dashboard" &&
	// 	pathname !== "/404" &&
	// 	!permission?.includes(pathname.replace(/\/(\d+)$/, ""))
	// ) {

	// 	return <Navigate to="/404" replace />;
	// }

	return children;
}

export default ProtectedRoute;
